import React, { memo } from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const NetworkFailedIcon = ({ className, width, height, color }) => {
  const classes = useStyles({ width, height });

  return (
    <SvgIcon className={clsx(className, classes.root)} width={width} height={height} viewBox="0 0 24 24" color={color}>
      <path
        d="M17.1 14.2751L15.875 13.05C16.2417 12.6167 16.5208 12.1417 16.7125 11.625C16.9042 11.1084 17 10.5667 17 10C17 9.33338 16.8667 8.70005 16.6 8.10005C16.3333 7.50005 15.9667 6.96672 15.5 6.50005L16.7 5.30005C17.3333 5.93338 17.825 6.65005 18.175 7.45005C18.525 8.25005 18.7 9.10005 18.7 10C18.7 10.8 18.5583 11.5625 18.275 12.2875C17.9917 13.0125 17.6 13.675 17.1 14.2751ZM14.125 11.3L10.7 7.87505C10.9 7.75838 11.1083 7.66672 11.325 7.60005C11.5417 7.53338 11.7667 7.50005 12 7.50005C12.7 7.50005 13.2917 7.74172 13.775 8.22505C14.2583 8.70838 14.5 9.30005 14.5 10C14.5 10.2334 14.4667 10.4584 14.4 10.675C14.3333 10.8917 14.2417 11.1 14.125 11.3ZM19.5 16.6501L18.3 15.4501C18.9667 14.7001 19.4667 13.8542 19.8 12.9125C20.1333 11.9709 20.3 11 20.3 10C20.3 8.90005 20.0958 7.83755 19.6875 6.81255C19.2792 5.78755 18.6833 4.88338 17.9 4.10005L19.1 2.90005C20.0167 3.86672 20.7292 4.95838 21.2375 6.17505C21.7458 7.39172 22 8.66672 22 10C22 11.2334 21.7875 12.4209 21.3625 13.5625C20.9375 14.7042 20.3167 15.7334 19.5 16.6501ZM19.775 22.6L13 15.8251V21H11V13.825L6.99999 9.85005V10C6.99999 10.6667 7.13333 11.3 7.39999 11.9C7.66666 12.5 8.03333 13.0334 8.49999 13.5L7.29999 14.7001C6.66666 14.0667 6.17499 13.35 5.82499 12.55C5.47499 11.75 5.29999 10.9 5.29999 10C5.29999 9.71672 5.31666 9.44172 5.34999 9.17505C5.38333 8.90838 5.44166 8.63338 5.52499 8.35005L4.24999 7.07505C4.06666 7.55838 3.92916 8.04172 3.83749 8.52505C3.74583 9.00838 3.69999 9.50005 3.69999 10C3.69999 11.1 3.90416 12.1625 4.31249 13.1875C4.72083 14.2126 5.31666 15.1167 6.09999 15.9001L4.89999 17.1C3.98333 16.1334 3.27083 15.0417 2.76249 13.825C2.25416 12.6084 1.99999 11.3334 1.99999 10C1.99999 9.26672 2.07916 8.54588 2.23749 7.83755C2.39583 7.12922 2.63333 6.44172 2.94999 5.77505L1.39999 4.22505L2.79999 2.80005L21.2 21.2001L19.775 22.6Z"
        fill={color}
      />
    </SvgIcon>
  );
};
NetworkFailedIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,

  color: PropTypes.string,
};
NetworkFailedIcon.defaultProps = {
  width: 24,
  height: 24,

  color: "white",
};

export default memo(NetworkFailedIcon);

const useStyles = makeStyles(() => ({
  root: {
    width: props => props.width,
    height: props => props.height,
  },
}));
